"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function resolveEventStreamSerdeConfig(input) {
  return Object.assign(Object.assign({}, input), {
    eventStreamMarshaller: input.eventStreamSerdeProvider(Object.assign({}, input))
  });
}

exports.resolveEventStreamSerdeConfig = resolveEventStreamSerdeConfig;